import { render } from "./header-two.vue?vue&type=template&id=54f4c66e"
import script from "./header-two.vue?vue&type=script&lang=js"
export * from "./header-two.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__